export const createTranslationFetcher =
  (country: string, language: string) => async () => {
    try {
      const url = `${
        import.meta.env.VITE__LOCALE_PREFIX
          ? `${import.meta.env.VITE__LOCALE_PREFIX}/`
          : "/"
      }${country}/${language}/saleslead/translations/${language}-${country.toLocaleUpperCase()}.json`;

      const res = await fetch(url);
      return await res?.text();
    } catch {
      /* If file is not found etc. assume no setting exists */
      return "";
    }
  };
